export default __webpack_public_path__ + "static/media/logo-instagram.99b7ab84.svg";